<template>
  <div v-if="$slots.default" class="error" v-bind="$attrs" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EError',
};
</script>

<style lang="scss" scoped>
.error {
  font-family: $family;
  color: $coral-50;
  font-size: $font-m;
  line-height: $line-height-m;
}
</style>
